import React, { useEffect, useMemo, useState } from "react";

import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ImageResize } from "quill-image-resize-module-ts";
import * as String from "../commons/string";
import { useMediaQuery } from "react-responsive";

import { Button, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

Quill.register("modules/imageResize", ImageResize);

function BBSEditor({
    value,
    hasAttachFiles,
    readOnly,
    disabled,
    onChange,
}: {
    value?: string;
    hasAttachFiles?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    onChange?: (contents: string, attachFiles: any[]) => void;
}) {
    const isMobile = useMediaQuery({ maxWidth: 550 });
    const [attachFiles, setAttachFiles] = useState<Array<any>>([]);
    const [contents, setContents] = useState("");

    useEffect(() => {
        value !== undefined && setContents(value);
    }, [value]);

    const modules = useMemo(
        () => ({
            toolbar: {
                container: isMobile
                    ? [["image"]]
                    : [
                          ["bold", "italic", "underline", "strike", "blockquote"],
                          [{ size: ["small", false, "large", "huge"] }, { color: [] }],
                          [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }, { align: [] }],
                          ["link", "image"],
                      ],
            },
            imageResize: {
                parchment: Quill.import("parchment"),
                modules: ["Resize", "DisplaySize", "Toolbar"],
            },
        }),
        []
    );

    const propsAttachFiles = {
        onRemove: (file: any) => {
            const index = attachFiles.indexOf(file);
            const newAttachFiles = attachFiles.slice();
            newAttachFiles.splice(index, 1);
            setAttachFiles(newAttachFiles);

            onChange !== undefined && onChange(contents, newAttachFiles);
        },
        beforeUpload: (file: any) => {
            setAttachFiles([...attachFiles, file]);
            onChange !== undefined && onChange(contents, [...attachFiles, file]);

            return false;
        },
        fileList: attachFiles,
    };

    const contentChange = (value: string) => {
        setContents(value);
        onChange !== undefined && onChange(value, attachFiles);
    };

    return (
        <>
            <ReactQuill
                style={{
                    pointerEvents: disabled ? "none" : "auto",
                    background: disabled ? "rgba(0, 0, 0, 0.04)" : "",
                    cursor: disabled ? "not-allowed" : "",
                }}
                value={contents}
                onChange={(value) => contentChange(value)}
                modules={modules}
                theme="snow"
                placeholder="내용을 입력해 주세요."
                readOnly={readOnly}
            />
            {hasAttachFiles && (
                <Upload {...propsAttachFiles}>
                    <Button icon={<UploadOutlined />}>{String.attachment}</Button>
                </Upload>
            )}
        </>
    );
}

export default BBSEditor;
